module.exports = __webpack_public_path__ + "static/choose-us-538b0524ba3e22411f16b79396c7a08e.png";